module.exports = __webpack_public_path__ + "static/about-5ef39a2e5f2c81a57e682bfb745fcee8.png";